<div class="auto-complete" [class.disabled]="disabled()">
  @if (!open) {
    @if (allowNone() && selectedOptions().length === 0) {
      <div class="auto-complete-label" [class.disabled]="disabled()" (click)="openAndSetFocus()">
        <span class="auto-complete-selected-value"></span>
      </div>
    } @else if (disabledPlaceholder()) {
      <div class="auto-complete-label" [class.disabled]="disabled()">
        <span class="auto-complete-selected-value">{{ disabledPlaceholder() }}</span>
      </div>
    } @else {
      <app-tooltip-wrapper>
        <div class="auto-complete-label" [class.disabled]="disabled()" (click)="openAndSetFocus()">
          @for (selectedOption of selectedOptions(); track selectedOption.name) {
            @if (selectedOption.image && !settings.hideIconsInDropdowns()) {
            <span class="auto-complete-selected-value"><img class="inline-image" [src]="imgPrefix + selectedOption.image" /> @if (!isMobile()) { {{ selectedOption.name }} }</span>
            } @else {
              <span class="auto-complete-selected-value">{{ selectedOption.name }}</span>
            }
          }
        </div>
        @if (showTooltip() && selectedOptions().length > 1) {
          <ng-template #tooltip>
            @for (selectedOption of selectedOptions(); track selectedOption.name) {
              @if (selectedOption.image) {
              <p class="auto-complete-selected-value">
                <span class="image-container"><img class="inline-image" [src]="imgPrefix + selectedOption.image" /></span> {{ selectedOption.name }}</p>
              } @else {
                <p class="auto-complete-selected-value">{{ selectedOption.name }}</p>
              }
            }
          </ng-template>
        }
      </app-tooltip-wrapper>
    }
  } @else {
  <div class="auto-complete-select">
    <div class="auto-complete-input">
      <input #autoCompleteInputElement [placeholder]="formattedSelectedValues()" type="text" class="form-control"
        [(ngModel)]="searchText" (ngModelChange)="searchText.set($event)">

      <button class="btn close-btn" (click)="close()">OK</button>
    </div>
    <div class="auto-complete-options poe-scrollbar" (keydown.enter)="close()">
      @if (allowAll()) {
        <div class="auto-complete-option" [class.selected]="isSelected(allLabel())" (click)="toggle(allLabel())">{{ allLabel() }}</div>
      }
      @if (showOptions()) {
        @for (baseType of filteredOptions(); track $index) {
          <div class="auto-complete-option" [class.selected]="isSelected(baseType.name)"
            (click)="toggle(baseType.name)" (mouseenter)="hovered(baseType.name)" (mouseleave)="unhovered()">
            <span class="option-content">
              @if (baseType.image) {
                <span class="image-container"><img class="inline-image" [src]="imgPrefix + baseType.image" /></span>
              }
              {{ baseType.name }}
            </span>
            @if (baseType.gearTier) {
              <span class="option-gear-tier">
                <app-gear-tier-icon [tier]="baseType.gearTier" />
              </span>
            } @else if (baseType.jewelleryTier) {
              <span class="option-gear-tier">
                <app-jewellery-tier-icon [tier]="baseType.jewelleryTier" />
              </span>
            }
          </div>
        }
      }
    </div>
    @if (extraInfo && extraInfo.length > 0) {
      <div class="auto-complete-info-container">
        @if (settings.showValueInDropdowns() && value) {
          <div class="auto-complete-value" app-value [value]="value" [rtl]="true" [round]="2"></div>
        }
        <div class="auto-complete-info">
          @for (info of extraInfo; track $index) {
            <div [innerHTML]="info"></div>
          }
        </div>
      </div>
    }
  </div>
  }
</div>
